import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-next-top-navigation w-full" }
const _hoisted_2 = { class: "hidden max-w-screen-2xl m-auto md:grid grid-cols-3 lg:grid-cols-6 h-full" }
const _hoisted_3 = { class: "m-auto md:hidden h-full flex justify-end pr-3" }
const _hoisted_4 = { class: "menu" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TopNavigationButton = _resolveComponent("TopNavigationButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_TopNavigationButton, {
        href: "https://nextyu-qaprod.nextgroup.eu/",
        target: "_blank",
        "icon-class": "icon-foo"
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createTextVNode(" CRM ")
        ])),
        _: 1
      }),
      _createVNode(_component_TopNavigationButton, {
        "icon-class": "icon-contatto",
        href: "https://nextyu-qaprod.nextgroup.eu/suppliers/",
        target: "_blank"
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [
          _createTextVNode("ALBO FORNITORI ")
        ])),
        _: 1
      }),
      _createVNode(_component_TopNavigationButton, {
        "icon-class": "icon-catena_orizzontale",
        is: 'router-link',
        to: {name:'ListaProgetti'},
        active: _ctx.isActive === 'prj'
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [
          _createTextVNode("PROGETTI ")
        ])),
        _: 1
      }, 8, ["active"]),
      _createVNode(_component_TopNavigationButton, {
        "icon-class": "icon-timesheet",
        href: "https://nextyu-qaprod.nextgroup.eu/timesheet/",
        target: "_blank"
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [
          _createTextVNode("TIMESHEET ")
        ])),
        _: 1
      }),
      _createVNode(_component_TopNavigationButton, {
        "icon-class": "icon-catena_verticale",
        is: "a",
        target: "_blank",
        href: "https://profilo.sistemi.com/Account/Login?ReturnUrl=%2Fwsfed%2Fcallback%3Fwa%3Dwsignin1.0%26wtrealm%3Dhttps%253A%252F%252Fjobrisorse.sistemi.com%252F%26wctx%3Drm%253D0%2526id%253Dpassive%2526ru%253D%25252f"
      }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [
          _createTextVNode("Gestione HR ")
        ])),
        _: 1
      }),
      _createVNode(_component_TopNavigationButton, {
        "icon-class": "icon-tre_rettangoli",
        is: "a",
        target: "_blank",
        href: "https://grupponext.sharepoint.com/sites/documenti_intranet/Documenti/Forms/AllItems.aspx"
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [
          _createTextVNode("Documenti ")
        ])),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.open) = $event)),
        id: "menu-toggle",
        type: "checkbox"
      }, null, 512), [
        [_vModelCheckbox, _ctx.open]
      ]),
      _cache[8] || (_cache[8] = _createElementVNode("label", {
        class: "menu-button-container",
        for: "menu-toggle"
      }, [
        _createElementVNode("div", { class: "menu-button" })
      ], -1)),
      _createElementVNode("ul", _hoisted_4, [
        _createElementVNode("li", null, [
          _createVNode(_component_TopNavigationButton, {
            "icon-class": "icon-crm",
            to: {name:'Timesheet'},
            is: "router-link",
            active: _ctx.isActive === 'tim',
            class: "w-full"
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createTextVNode(" Timesheet ")
            ])),
            _: 1
          }, 8, ["active"])
        ])
      ])
    ])
  ]))
}